module.exports = __webpack_public_path__ + "img/pencil_icon.212e77eb.svg";